import { createContext, ReactNode, useContext } from "react";
import { MetaFilterConfig } from "./types";

export const Context = createContext<MetaFilterConfig | null>(null);

type MetaFilterConfigProviderProps = {
  config: MetaFilterConfig;
  children: ReactNode;
};

export function MetaFilterConfigProvider({
  children,
  config,
}: MetaFilterConfigProviderProps) {
  return <Context.Provider value={config}>{children}</Context.Provider>;
}

export function useMetaFilterConfig() {
  return useContext(Context);
}
